import { FETCH_PUBLIC_DATASETS } from './types';
import api from '../apis/api';
import store from '../store';
import getMessageFromApiError from '../util/getMessageFromApiError';
import { setErrorMessage } from './errorMessage';

export const fetchPublicDatasets = () => async (dispatch) => {
  try {
    let res = await api.get('/dataset/public');
    dispatch({
      type: FETCH_PUBLIC_DATASETS,
      payload: res.data,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const verifyPublicDatasets = () => async (dispatch) => {
  const publicDatasets = store.getState().publicDatasets;
  if (publicDatasets.length === 0) {
    dispatch(fetchPublicDatasets());
  }
};
